// Common API's
const GetWorkOrderTypesAndCategories = 'Common/GetWorkOrderTypesAndCategories'
const GetWorkorderStages = 'Common/GetWorkorderStages'
const GetCountryStates = 'Common/GetCountryStates'
const GetDocumentTemplateData = 'Common/GetDocumentTemplateData'
const GetVesselByOfficialNumber = 'Common/GetVesselByOfficialNumber'
const GetSearchAgent = 'Common/SearchAgents'
const GetAgentDetailsById = "Common/GetAgentDetailsById"
const GetCustomerCompanyDetails = 'Common/GetAgentsByEmail'
const GetSupportingDocuments = 'Common/GetSupportingDocuments'
const SendFeedbackEmail = 'Common/SendFeedbackEmail'
const GetQuestions = 'Common/GetQuestions'
const GetComValidateSCDUserDetails = 'Common/ValidateSCDUserDetails'
const GetApplicationData = 'GetApplicationData'
const GetUsers = 'UserManagement/GetUsers'
const GetUserRoles = 'UserManagement/GetUserRoles'
const SaveUserRoles = 'UserManagement/SaveUserRoles'
const SearchMPList = '/Dashboard/SearchMPList'

// Cancel & Replace API's
const GetInActiveInvoiceById = 'Common/GetInActiveInvoiceById'
const GetAccountByAgentId = "Common/GetAccountByAgentId"
const GetWorkorderProducts = "GetWorkorderProducts"
const CancelAndReplaceWorkorderInvoice = "CancelAndReplaceWorkorderInvoice"
const GetDiscountProductCodeAmount = "Common/GetDiscountProductCodeAmount"

// Dashboard API's
const GetCustomerWorkorders = 'Dashboard/GetCustomerWorkorders'
const FilterWorkorders = 'Dashboard/FilterWorkorders'
const GetVesselDashboard = 'getVesselDashboard'
const GetTotalInvoiceRevenue = 'Dashboard/GetTotalInvoiceRevenue'
const GetWorkOrdersDataByAgentId = "Dashboard/GetWorkOrdersDataByAgentId"
const GetSCDUsersByAgentId = "Dashboard/GetSCDUsersByAgentId"
const GetSEAPortalRevenues = "Dashboard/GetSEAPortalRevenues"
const GetAffiliatesByAgentId = "Dashboard/GetAffiliatesByAgentId"
const GetActiveAgentsBreakdown = "Dashboard/GetActiveAgentsBreakdown"
const GetWorkorderProductCodes = "Dashboard/GetWorkorderProductCodes"
const GetMPDetailsFilter = "Dashboard/GetMPDetailsFilter"
const GetMPWorkOrdersDataByAgentId = "Dashboard/GetMPWorkOrdersDataByAgentId"
const GetCrewApplicationDashboard = 'Dashboard/GetCrewApplicationDashboard'
const GetSubmitApplicationDashboard = 'Dashboard/GetSubmitApplicationDashboard'
const GetAppVersions = 'AppVersion/GetAppVersions'
const AppVersionDisableEnabled = 'AppVersion/AppVersionDisableEnabled'
const CreateAppVersion = 'AppVersion/CreateAppVersion'


// Company API's
const GetCompanyDetails = 'Company/GetCompaniesList'
const ValidateWorkorderCreation = 'ValidateWorkorderCreation'
const GetSFRCompaniesByName = 'Company/GetCompaniesByName'
const GetSFRCompanies = 'Company/GetCustomerCompanies'
const GetCompaniesByName = 'GetSFRCompaniesByName'
const GetTrainingCenterAddressDetails = 'GetTrainingCenterAddressDetails'
const GetApprovedCourseDetails = 'GetApprovedCourseDetails'
const GetApprovedCourses = 'GetApprovedCourses'
const GetApprovedCoursesAndReferences = 'GetApprovedCoursesAndReferences'
const GetCourseDetails = 'GetCourseDetails'
const GetApprovedCapacityofCertificate = 'GetApprovedCapacityofCertificate'
const GetCrewCapacity = "GetApprovedCapacityofCertificate"
const GetApprovedCourseReferences = 'GetApprovedCourseReferences'
const GetApprovedInstructors = "GetApprovedInstructors"

// Workorders API's
const GetBaseWorkOrderData = 'GetBaseWorkOrderData'
const GetAgentInformationnData = 'GetApplicationData'
const CreateWorkorder = 'CreateWorkorder'
const UpdateWorkorderData = 'UpdateWorkorderData'
const GetWorkorderById = 'GetWorkorderById'
const UpdateWorkorder = 'UpdateWorkorder'
const AcceptProofOfAffliationDoc = 'AcceptProofOfAffiliationDoc'
const SyncAffiliateDetailsWithSCD = 'SyncAffiliateDetailsWithSCD'
const RemoveWorkorderDocument = 'FileUpload/RemoveWorkorderDocument'
const RequestMoreInfo = 'RequestMoreInfo'
const RejectProofOfAffliationDoc = 'RejectProofOfAffiliationDoc'
const GetInvoiceDocument = 'GetInvoiceDocument'
const GetSAPInvoicePrintStatus = 'GetSAPInvoicePrintStatus'
const GetCCGPreviewAgreement = 'GetCCGPreviewAgreement'
const GetcasInvoiceDocument = 'GetcasInvoiceDocument'
const GetFaaInvoiceDocument = 'GetAffInvoiceDocument'
const GetPreviewDocument = 'PreviewAuthorizationDocument'
const UpdateNeedMoreInfoStatus = 'UpdateNeedMoreInfoStatus'
const CancelWorkorder = 'CancelWorkorder'
const SuspendWorkorder = 'SuspendWorkorder'
const VoidWorkOrder = 'VoidWorkOrder'
const ArchivedWorkorder = 'ArchivedWorkorder'
const ResendDocusignEmail = 'ResendDocusignEmail'
const ValidateAgentName = 'ValidateAgentName'
const GetProductCodes = 'GetProductCodes'
const AddorRemoveProformaInvoice = 'AddorRemoveProformaInvoice'
const UpdateProductCodes = 'UpdateProductCodes'
const UpdateProformaInvoice = 'UpdateProformaInvoice'
const CompareAffiliateDetailsWithScd = "CompareAffiliateDetailsWithScd"
const GetCCGCOPYAgreement = 'GetCCGCOPYAgreement'

// Workorder Comments Api's
const GetWorkorderComments = 'WorkorderComment/GetWorkorderComments'
const CreateComment = 'WorkorderComment/CreateComment'
const UpdateBillingPrefix = 'UpdateBillingPrefix'
const UpdateResendEmail = 'ResendEmail'
const RegenerateAuthorizationLetter = 'RegenerateAuthorizationLetter'
const UpdateNdaDocument = 'UpdateNdaDocument'

// Seafarer API's
const ValidateUsersByEmailslist = 'User/ValidateUsersByEmailslist'
const ValidateSCDUserDetails = 'ValidateSCDUserDetails'
const GetAffliationParentData = 'GetAffliationParentData'
const ValidateAgentNumber = 'ValidateAgentNumber'
const RetryAddAgentContact = 'RetryUsersCreation'
const GetFilesDataByFolderName = 'FileUpload/GetFilesDataByFolderName'
const DownloadDocument = 'FileUpload/DownloadDocument'
const DeleteDocument = 'FileUpload/DeleteDocument'
const GetCASSupportingDocuments = 'Common/GetSupportingDocuments'
const GetCasAgreemet = 'GetCasAgreement'
const GetFamAgreement = 'GetFamAgreement'
const GetAffAgreement = 'GetAffAgreement'
const GetTCAAgreement = 'GetTCAAgreement'
const GetAgreement = 'GetAgreement'
const CreateQuestionResponse = 'Common/CreateQuestionResponse'
const UpdateQuestionResponse = 'common/UpdateQuestionResponse'
const RefreshSeaData = 'RetryAddAgentContact'
const DownloadFile = "DownloadFile"
const RefreshVesselData = "RefreshVesselData"
const RefreshScdUsers = "RefreshScdUsers"
const GetVesslesByAgentId = 'GetVesslesByAgentId'
const GetUsersByAgentId = 'GetUsersByAgentId'
const GetRcaInvoiceDocument = 'GetRcaInvoiceDocument'
const GetRcaAgreement = 'GetRcaAgreement'
const ValidateRaAgentName = 'ValidateAgentName'
const GetCourseCopyForUsers = "GetCourseCopyForUsers"
const GnerateInvoice = "GnerateInvoice"
const GetUsersBySearch = "UserManagement/GetUsersBySearch"
const GetUsersByAgentIds = "UserManagement/GetUsersByAgentIds"
const GetUserCompanies = "UserManagement/GetUserCompanies"
const SEAPortalRevenuesDownloadExcel = "Dashboard/SEAPortalRevenuesDownloadExcel"
const UpdateUserCompanyMapping = "UserManagement/UpdateUserCompanyMapping"
const CreateUserCompanyMapping = 'UserManagement/CreateUserCompanyMapping'
const GetUsersByEmailKeyword = "GetUsersByEmailKeyword"
const GetCrewByFIN = "GetCrewByFIN"
const GetTrainingCenterEmails = "GetTrainingCenterEmails"
const GetCADetails = "GetCADetails"
const GetTrainingDetailsByParentWorkorderId = "GetTrainingDetailsByParentWorkorderId"
const FilterCodes = "Common/FilterCodes"
const ValidateCodesDetails = "ValidateCodesDetails"
const GetWorkOrderFilesByFileId = 'FileUpload/GetWorkOrderFilesByFileId'
const CheckCodes = "Common/CheckCodes"
const GetAuditReport = "GetAuditReport"
const ProcessAuditReportStage = "processAuditReportStage"
const getAllInstructorDetails = 'GetInstructorDetails'
const ValidateCode = "Common/ValidateCode"
const GetCrewsList = "GetCrewsList"
const GetCrewDetailsByFinId = "GetCrewDetailsById"
const GetServiceProviderAgents = "GetServiceProviderAgents"
const RejectWorkOrder = "RejectWorkOrder"
const GetAffiliateAgents = "GetAffiliateAgents"
const ValidatePractionerId = "ValidatePractionerId"
const GetBookTypes = "Common/GetBookTypes"
const GetBookIssueTypes = "Common/GetBookIssueTypes"
const GetLicenseLevel = "Common/GetLicenseLevel"
const GetLicenseIssueTypes = "Common/GetLicenseIssueTypes"
const GetLicenseCapacity = "Common/GetLicenseCapacity"
const GetLicenseGrade = "Common/GetLicenseGrade"
const GetVessels = "GetVessels"
const GetVesselTypes = "Common/GetVesselTypes"
const GetSQCTypes = "Common/GetSQCTypes"
const GetSQCCodeList = "GetSQCCodeList"
const GetSQCIssueTypes = "Common/GetSQCIssueTypes"
const GetFlags = "Common/GetFlagList"
const GetCrewApplicationsByAgentId = "common/GetCrewApplicationsByAgentId"
const GetCrewsByAgentId = "common/GetCrewsByAgentId"
const FilterCrewApplications = "FilterCrewApplications"
const GetBillToAndShipToAgents = "GetBillToAndShipToAgents"
const GetValidCrewsList = "GetValidCrewsList"
const GetHairAndEyeColor = 'common/GetHairAndEyeColor'
const GetCertificateTypes = 'common/GetCertificateTypes'
const GetCertificateCategory = 'common/GetCertificateCategory'
const GetCOCdetails = 'common/GetCOCdetails'
const GetDownloadData = "GetDownloadData"
const GetBookSequenceData = "common/GetBookSequenceData"
const InsertBookSequence = "common/InsertBookSequence"
const UpdateBookSequence = "common/UpdateBookSequence"
const GetSystemProcessingOffie = "common/GetSystemProcessingOffice"
const GenerateFin = "GenerateFin"
const DeleteBookSequenceById = "common/DeleteBookSequenceById"
const GetSigner = "GetSigner"
const CreateBook = "CreateBook"
const FilterCrew = "FilterCrew"
const UpdateMatchFin = "UpdateMatchFin"
const GenerateDocuments = "GenerateDocuments"
const GetPaymentTypesByCompanyId = "GetPaymentTypesByCompanyId"
const GetAppProductCodes = "GetProductCodes"
const UpdateCAPWorkOrderStage = "UpdateCAPWorkOrderStageToBound"
const GetCAPWorkorderList = "GetCAPWorkorderList"
const GetDocumentHistory = "GetDocumentHistory"
const RegenerateDocuments = "RegenerateDocuments"
const GetProductCertificateIssueMappings = "Common/GetProductCertificateIssueMappings"
const GetSeaServices = "GetSeaServices"
const GetPortsList = "Common/GetPortsList"
const GetApprovedAndPendingCrewsByAgentIdAndKeyword = "GetApprovedAndPendingCrewsByAgentIdAndKeyword"
const GetAllTypes = "Common/GetAllTypes"
const GetDownloadCertData = "GetDownloadData"
const DeactivateRole = "DeactivateRole"
const GetPaymentStatus = "GetPaymentStatus"
// const GetCAPProductCodes = "GetProductCodes"
const GetSAPProductCodes = "GetCrewApplicationProductCodes"
const GetLicenceFunctionLimitByDepartmentAndLevel = "GetLicenceFunctionLimitByDepartmentAndLevel"
const GetAllCrew = "Dashboard/GetAllCrew"
const OrderSummary = "Dashboard/FilterOrderSummary"
const PrintFiles = "PrintFiles"
const GetCrewApplications = "Dashboard/GetCrewApplications"
const ApplicationServiceRejection = "ApplicationServiceRejection"

const GetVesselData = "Dashboard/GetVesselData"
const GetSCDClientUsersByAgentId = "Dashboard/GetSCDClientUsersByAgentId"
const GetValidateCAPsGatePassed = "ValidateSAPsGatePassed"
const UpdateCrewApplicationIssuedDocuments = "UpdateCrewApplicationIssuedDocuments"
const ValidateMedicalCode = "ValidateMedicalCode"
const UpdateSAPMiscCharges = "UpdateSAPMiscCharges"
const GetPrinters = "Print/GetPrinters"
const GetOutputTrays = "Print/GetOutputTrays"
const CreateUserPrinterMapping = "Print/CreateUserPrinterMapping"
const GetUserPrinterMappings = 'Print/GetUserPrinterMappings'
const ResendPendingDocumentsToVault = 'ResendPendingDocumentsToVault'
const ValidateCrewEmail = 'ValidateCrewEmail'
const ValidatePhysicalSerialNumber = "ValidatePhysicalSerialNumber"
const GetSQCLevel = "Common/GetSQCLevel"
const GetDiscountedProductsCAP = "GetDiscountedProductsCAP"
const GetComplianceApplicationStatus = "SubmitApplicationForComplianceCheck"
const GetProductCodeData = "GetProductCodeData"
const AmendBook = 'AmendBook'
const GetCrewInformation = 'Dashboard/GetCrewInformation'
const UpdateCrewDetails = 'FA/MC/UpdateCrewDetails'
const SendAlertEmail = 'SendAlertEmail'
const UpdateWorkOrderPaymentMode = 'UpdateWorkOrderPaymentMode'
const GetCrewNotifications = 'GetCrewNotifications'
const GetBookEnquiryData = "Crew/GetBookInquiryData"
const GetSQCInquiryData = "Crew/GetSQCInquiryData"
const GetLicenseInquiryData = "Crew/GetLicenseInquiryData"
const GetInquiryLookupData = "Crew/GetInquiryLookupData"
const GetBookInformation = "FA/CAP/GetBookInformation"
const GetSqcInformation = "FA/CAP/GetSQCInformationData"
const GetLicenseInformationData = "FA/CAP/GetLicenseInformationData"
const UpdateBook = "Crew/UpdateBook"
const UpdateSQC = "Crew/UpdateSQC"
const UpdateLicense = "Crew/UpdateLicense"
const UpdateSubmissionExpedite = "Dashboard/UpdateSubmissionExpedite"
const GetCloneWorkorderById = "GetCloneWorkorderById"
const GetSubmissionReport = "Reports/GetSubmissionReport"
const GetBookSalesAnalysis = "Reports/GetBookSalesAnalysis"
const GetCurrentWorkOrderStateCounts = "Reports/GetCurrentWorkOrderStateCounts"
const GetWorkOrderSummaryStatistics = "Reports/GetWorkOrderSummaryStatistics"
const GetMiscChargesStatistics = "Reports/GetMiscChargesStatistics"
const GetSqcSignerStatistics = "Reports/GetSqcSignerStatistics"
const GetSeafarerStatistics = "Reports/GetSeafarerStatistics"
const GetDocumentChargesStatistics = "Reports/GetDocumentChargesStatistics"
const GetWorkOrdersWithVessel = "Reports/GetWorkOrdersWithVessel"
const GetWorkOrdersWithCrew = "Reports/GetWorkOrdersWithCrew"
const GetLicenseRenewals = "Reports/GetLicenseRenewals"
const GetSalesAnalysisMiscFee = "Reports/GetSalesAnalysisMiscFee"
const GetClosedWorkOrders = "Reports/GetClosedWorkOrders"
const GetWorkOrderHistory = "crew/GetWorkOrderHistory"
const GetApplicationHistory = "crew/GetApplicationHistory"
const GenerateCRA = "GenerateCRA"
const RemoveCAPProductCode = "RemoveCrewProductCode"
const GetFilingAgentAddressDetails = "GetFilingAgentAddressDetails"
const GetOrderSummary = "GetOrderSummaryDocument"
const GetAgentPayments = "Common/GetAgentPayments"
export const ApiUrls = {
    RemoveCAPProductCode,
    GetFilingAgentAddressDetails,
    GetInActiveInvoiceById,
    GetCloneWorkorderById,
    GetInquiryLookupData,
    GetSqcInformation,
    GetSQCInquiryData,
    GetLicenseInquiryData,
    GetBookEnquiryData,
    AmendBook,
    GetComplianceApplicationStatus,
    GetDiscountedProductsCAP,
    ValidatePhysicalSerialNumber,
    ResendPendingDocumentsToVault,
    UpdateSAPMiscCharges,
    GetAccountByAgentId,
    GetWorkorderProducts,
    CancelAndReplaceWorkorderInvoice,
    GetDiscountProductCodeAmount,
    GetAffiliateAgents,
    UpdateCrewApplicationIssuedDocuments,
    GetSCDClientUsersByAgentId,
    GetSAPProductCodes,
    RegenerateDocuments,
    UpdateCAPWorkOrderStage,
    GetCAPWorkorderList,
    GetAppProductCodes,
    GetPaymentTypesByCompanyId,
    GenerateFin,
    FilterCrew,
    UpdateMatchFin,
    GetCrewsByAgentId,
    GetCrewApplicationsByAgentId,
    ValidatePractionerId,
    GetWorkOrderTypesAndCategories,
    GetWorkorderStages,
    GetWorkOrderFilesByFileId,
    GetCountryStates,
    GetDocumentTemplateData,
    GetCustomerWorkorders,
    FilterWorkorders,
    ValidateCodesDetails,
    GetVesselDashboard,
    GetCompanyDetails,
    GetCustomerCompanyDetails,
    ValidateWorkorderCreation,
    GetSFRCompaniesByName,
    GetApplicationData,
    GetCompaniesByName,
    GetTrainingCenterAddressDetails,
    GetApprovedCourseDetails,
    GetApprovedCourses,
    GetApprovedCoursesAndReferences,
    GetCourseDetails,
    GetApprovedCapacityofCertificate,
    GetApprovedCourseReferences,
    GetApprovedInstructors,
    GetSFRCompanies,
    GetBaseWorkOrderData,
    GetAgentInformationnData,
    GetAffliationParentData,
    ValidateAgentNumber,
    CreateWorkorder,
    UpdateWorkorderData,
    GetWorkorderById,
    UpdateWorkorder,
    FilterCrewApplications,
    AcceptProofOfAffliationDoc,
    RemoveWorkorderDocument,
    RequestMoreInfo,
    ValidateUsersByEmailslist,
    RejectProofOfAffliationDoc,
    GetInvoiceDocument,
    GetSAPInvoicePrintStatus,
    GetCCGPreviewAgreement,
    GetcasInvoiceDocument,
    GetFaaInvoiceDocument,
    GetPreviewDocument,
    UpdateNeedMoreInfoStatus,
    CancelWorkorder,
    SuspendWorkorder,
    ArchivedWorkorder,
    ResendDocusignEmail,
    CreateQuestionResponse,
    UpdateQuestionResponse,
    GetWorkorderComments,
    CreateComment,
    GetVesselByOfficialNumber,
    ValidateSCDUserDetails,
    GetComValidateSCDUserDetails,
    UpdateBillingPrefix,
    UpdateResendEmail,
    RegenerateAuthorizationLetter,
    DownloadFile,
    UpdateNdaDocument,
    RetryAddAgentContact,
    RefreshSeaData,
    GetFilesDataByFolderName,
    DownloadDocument,
    DeleteDocument,
    GetSearchAgent,
    GetCASSupportingDocuments,
    GetCasAgreemet,
    GetAffAgreement,
    GetFamAgreement,
    GetAgreement,
    GetTCAAgreement,
    RefreshVesselData,
    GetTotalInvoiceRevenue,
    GetSupportingDocuments,
    SendFeedbackEmail,
    ValidateAgentName,
    GetProductCodes,
    AddorRemoveProformaInvoice,
    UpdateProductCodes,
    SendFeedbackEmail,
    GetQuestions,
    GetApplicationData,
    GetWorkOrdersDataByAgentId,
    GetSCDUsersByAgentId,
    GetAffiliatesByAgentId,
    GetSEAPortalRevenues,
    GetActiveAgentsBreakdown,
    GetVesselByOfficialNumber,
    ValidateSCDUserDetails,
    GetComValidateSCDUserDetails,
    UpdateBillingPrefix,
    UpdateResendEmail,
    RegenerateAuthorizationLetter,
    DownloadFile,
    UpdateNdaDocument,
    RetryAddAgentContact,
    RefreshSeaData,
    GetFilesDataByFolderName,
    DownloadDocument,
    DeleteDocument,
    GetSearchAgent,
    GetAgentDetailsById,
    GetCASSupportingDocuments,
    GetCasAgreemet,
    GetFamAgreement,
    RefreshScdUsers,
    GetTotalInvoiceRevenue,
    GetSupportingDocuments,
    SendFeedbackEmail,
    ValidateAgentName,
    GetProductCodes,
    AddorRemoveProformaInvoice,
    UpdateProductCodes,
    UpdateProformaInvoice,
    SendFeedbackEmail,
    GetQuestions,
    GetApplicationData,
    GetUsers,
    GetUserRoles,
    SaveUserRoles,
    GetWorkorderProductCodes,
    GetCrewApplicationDashboard,
    GetSubmitApplicationDashboard,
    SyncAffiliateDetailsWithSCD,
    CompareAffiliateDetailsWithScd,
    GetVesslesByAgentId,
    GetUsersByAgentId,
    GetRcaInvoiceDocument,
    GetRcaAgreement,
    ValidateRaAgentName,
    GetCourseCopyForUsers,
    GnerateInvoice,
    GetUsersBySearch,
    GetUsersByAgentIds,
    GetUserCompanies,
    SEAPortalRevenuesDownloadExcel,
    UpdateUserCompanyMapping,
    CreateUserCompanyMapping,
    GetCCGCOPYAgreement,
    GetUsersByEmailKeyword,
    GetCrewByFIN,
    GetTrainingCenterEmails,
    FilterCodes,
    GetCADetails,
    GetTrainingDetailsByParentWorkorderId,
    CheckCodes,
    GetAuditReport,
    ProcessAuditReportStage,
    getAllInstructorDetails,
    ValidateCode,
    GetCrewsList,
    GetCrewDetailsByFinId,
    GetServiceProviderAgents,
    RejectWorkOrder,
    GetBookTypes,
    GetBookIssueTypes,
    GetLicenseLevel,
    GetLicenseIssueTypes,
    GetLicenseCapacity,
    GetVessels,
    GetLicenseGrade,
    GetVesselTypes,
    GetSQCTypes,
    GetFlags,
    GetBillToAndShipToAgents,
    GetValidCrewsList,
    GetHairAndEyeColor,
    GetCertificateTypes,
    GetCertificateCategory,
    GetSQCCodeList,
    GetSQCIssueTypes,
    GetCOCdetails,
    RejectWorkOrder,
    GetMPDetailsFilter,
    SearchMPList,
    GetMPWorkOrdersDataByAgentId,
    GetDownloadData,
    GetBookSequenceData,
    InsertBookSequence,
    UpdateBookSequence,
    GetSystemProcessingOffie,
    DeleteBookSequenceById,
    GetSigner,
    CreateBook,
    GenerateDocuments,
    GetDocumentHistory,
    GetProductCertificateIssueMappings,
    GetSeaServices,
    GetPortsList,
    GetCrewCapacity,
    GetApprovedAndPendingCrewsByAgentIdAndKeyword,
    GetAllTypes,
    GetDownloadCertData,
    DeactivateRole,
    GetPaymentStatus,
    GetLicenceFunctionLimitByDepartmentAndLevel,
    GetAllCrew,
    OrderSummary,
    PrintFiles,
    GetCrewApplications,
    GetValidateCAPsGatePassed,
    GetVesselData,
    ValidateMedicalCode,
    ApplicationServiceRejection,
    GetPrinters,
    GetOutputTrays,
    CreateUserPrinterMapping,
    GetUserPrinterMappings,
    ValidateCrewEmail,
    GetSQCLevel,
    GetAppVersions,
    AppVersionDisableEnabled,
    CreateAppVersion,
    GetProductCodeData,
    GetCrewInformation,
    UpdateCrewDetails,
    SendAlertEmail,
    UpdateWorkOrderPaymentMode,
    GetCrewNotifications,
    GetBookInformation,
    GetLicenseInformationData,
    UpdateBook,
    UpdateSQC,
    UpdateLicense,
    GetSubmissionReport,
    GetBookSalesAnalysis,
    GetCurrentWorkOrderStateCounts,
    GetWorkOrderSummaryStatistics,
    GetMiscChargesStatistics,
    GetSqcSignerStatistics,
    GetSeafarerStatistics,
    GetDocumentChargesStatistics,
    UpdateSubmissionExpedite,
    GetWorkOrdersWithVessel,
    GetWorkOrdersWithCrew,
    GetLicenseRenewals,
    GetSalesAnalysisMiscFee,
    GetClosedWorkOrders,
    GetWorkOrderHistory,
    GetApplicationHistory,
    GenerateCRA,
    VoidWorkOrder,
    GetOrderSummary,
    GetAgentPayments
}
